import { Flex } from "@mantine/core";

import classes from "./TimelineList.module.css";

export function TimelineListWrapper({
    children,
    mergedRef,
}: {
    children: React.ReactNode;
    mergedRef?: (element: unknown) => void;
}) {
    return (
        <Flex
            className={classes.wrapper}
            data-testid="timeline-list-wrapper"
            align="center"
            direction="column"
            ref={mergedRef}
        >
            {children}
        </Flex>
    );
}

export function List({
    children,
    IssueSummaryComponent,
}: {
    children: React.ReactNode;
    IssueSummaryComponent?: React.JSX.Element;
}) {
    return (
        <Flex data-testid="timeline-list" className={classes.list} direction="column" mb={0}>
            {IssueSummaryComponent}
            <ul>{children}</ul>
        </Flex>
    );
}
